import React, { useState, useContext } from "react";
import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import { Link } from "react-router-dom";
import { Input } from "design-react-kit";
import Pagination from "./Pagination";
import Select from "./Select";
import ModalComponent from "./ModalComponent";
import Repo from "../Utility/Repo";
import { TokenContext } from "./TokenContext";
import BodyGenerateCsv from "./BodyGenerateCsv";
import UserDataComponent from "./UserDataComponent";
import EmailIcon from "./EmailIcon ";
import FileDownload from "./FileDownload";
import Loader from "./Loader";

const ListUsers = (props) => {
  const apiToken = useContext(TokenContext);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [changeSort, setChangeSort] = useState(false);
  const [changeSortRanking, setChangeSortRanking] = useState(false);
  const [isOpenUnsubscribe, toggleModalUnsubscribe] = useState(false);
  const [isOpenDeleteAll, toggleModalDeleteAll] = useState(false);
  const [id, setId] = useState();
  const [userId, setUserId] = useState();
  const [editScore, toggleModalEditScore] = useState(false);
  const [fiscalcode, setSetFiscalcode] = useState();
  const [announcementId, setAnnouncementId] = useState("");
  const [isOpenRefuseUser, toggleRefuseUserModal] = useState(false);
  const [isOpenSuspendUser, toggleSuspendUserModal] = useState(false);
  const [isError, toggleModalErros] = useState(false);

  const [isOpenReactiveUser, toggleReactiveUserModal] = useState(false);
  const [isOpenReactiveRefusedUser, toggleReactiveRefusedUserModal] =
    useState(false);
  const [validation, setValidation] = useState(false);
  const [isOpenConfirmUser, toggleModalConfirmUser] = useState(false);
  const [isOpenConfirmHours, toggleModalConfirmHours] = useState(false);
  const [isOpenCSVUpload, toggleModalCSVUpload] = useState(false);
  const [editHours, toggleModalEditHours] = useState(false);
  const [isOpenGenerateCSV, toggleModalGenerateCSV] = useState(false);
  const [weeklyHour, setWeeklyHour] = useState();
  const [weeklyHourValidation, setWeeklyHourValidation] = useState(false);
  const [errorMessage, setErrorMessage] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [expandedRows, setExpandedRows] = useState({});

  const { operator, userData, delegate, user, citizen } = UserDataComponent();

  const [editScoreData, setEditScoreData] = useState({
    id: null,
    rankingScore: null,
    name: null,
  });
  const [sendImportCSV, setSendImportCSV] = useState({
    mese: "",
    anno: "",
  });

  const [editHoursData, setEditHoursData] = useState({
    id: null,
    weeklyHour: null,
    name: null,
  });

  const [file, setFile] = useState();

  const suspendUser = (state, sub) => {
    var obj = {};

    obj = {
      id: sub.id,
      state: state,
      weeklyHour: sub.weeklyHour,
    };

    Repo.postConfirmUser(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          props.apiGet();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      })
      .finally(() => {
        toggleModalConfirmUser(false);
        toggleRefuseUserModal(false);
        toggleReactiveUserModal(false);
        toggleSuspendUserModal(false);
        toggleReactiveRefusedUserModal(false);
      });
  };

  const viewToggleModalErros = () => {
    toggleModalErros(true);
  };

  const showFile = () => {
    Repo.downloadCsvOperator(apiToken)
      .then((response) => {
        if (response.status == 200) {
          const url = window.URL.createObjectURL(
            new Blob([response.data], { type: "text/csv" }),
          );
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            "Template_" + new Date().toLocaleDateString("it-IT") + ".csv",
          );
          document.body.appendChild(link);
          link.click();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      });
  };

  const confirmUser = (state, sub) => {
    let hoursValidation = true;
    var obj = {};

    if (state == 2) {
      setWeeklyHourValidation(true);

      obj = {
        id: sub.id,
        state: state,
        weeklyHour: weeklyHour,
      };
      if (weeklyHour == null) {
        hoursValidation = false;
      }
    } else {
      obj = {
        id: sub.id,
        state: state,
      };
    }

    Repo.postConfirmUser(apiToken, JSON.stringify(obj))
      .then((response) => {
        if (response.status == 200) {
          props.apiGet();
        }
      })
      .catch((error) => {
        setErrorMessage(
          error.response?.data?.Message ||
            error.response?.data ||
            "MESSAGE_ERROR_DEFAULT",
        );
        viewToggleModalErros();
      })
      .finally(() => {
        toggleModalConfirmUser(false);
        toggleRefuseUserModal(false);
      });
  };

  const returnBodyModalConfirmUser = () => {
    return (
      <>
        <div className="row p-2">
          {props.session.service &&
          props.session.service.name.toLowerCase().includes("taxi") ? (
            <p>
              Per confermare l'utente è necessario inserire il numero di corse:
            </p>
          ) : (
            <p>
              Per confermare l'utente è necessario inserire il numero di ore:
            </p>
          )}
        </div>
        <div className="row mt-3 d-flex justify-content-left">
          <div className="col-lg-6">
            <Input
              id="weeklyHour"
              label={
                props.session.service &&
                props.session.service.name.toLowerCase().includes("taxi")
                  ? "Corse"
                  : "Ore"
              }
              type="number"
              name="weeklyHour"
              onChange={(e) => setWeeklyHour(e.target.value)}
            />
          </div>
        </div>
      </>
    );
  };

  const returnBodyModalHoursUser = () => {
    return (
      <>
        <div className="row p-2">
          {props.session.service &&
          props.session.service.name.toLowerCase().includes("taxi") ? (
            <p>
              Per confermare l'utente è necessario inserire il numero di corse:
            </p>
          ) : (
            <p>
              Per confermare l'utente è necessario inserire il numero di ore:
            </p>
          )}
        </div>
        <div className="row mt-3 d-flex justify-content-left">
          <div className="col-lg-6">
            <Input
              id="weeklyHour"
              label={
                props.session.service &&
                props.session.service.name.toLowerCase().includes("taxi")
                  ? "Corse"
                  : "Ore"
              }
              type="number"
              name="weeklyHour"
              onChange={(e) => setWeeklyHour(e.target.value)}
            />
          </div>
        </div>
      </>
    );
  };

  const unsubscribeUser = () => {
    Repo.postUnsubscribeUser(apiToken, id, userId)
      .then((response) => {
        if (response.status == 200) {
          toggleModalConfirmUser(false);
          toggleModalUnsubscribe(!isOpenUnsubscribe);
          props.apiGet();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const deleteAllSubscriptions = () => {
    if (!props.session?.id) return;

    setIsLoading(true);
    Repo.postUnsubscribeAllUsers(apiToken, props.session.id)
      .then((response) => {
        if (response.status == 200) {
          toggleModalDeleteAll(false);
          props.apiGet();
        }
      })
      .catch((error) => {
        const message =
          error.response?.data?.Message ||
          error.response?.data ||
          "Non è stato possibile cancellare gli iscritti. Riprovare più tardi.";
        setErrorMessage(message);
        viewToggleModalErros();
      })
      .finally(() => {
        setIsLoading(false);
      });
  };

  const sendMyPay = () => {
    setIsLoading(true); // Inizia il caricamento
    Repo.sendMyPay(apiToken, announcementId, sendImportCSV, fiscalcode)
      .then((response) => {
        if (response.status === 200) {
          toggleModalGenerateCSV(!isOpenCSVUpload);
          console.log("Flusso inviato correttamente a MyPay");
          // setAlertMessage("Flusso inviato correttamente a MyPay");
        } else {
          // Gestire altri status di risposta se necessario
          setErrorMessage("Errore nella risposta dal server.");
          viewToggleModalErros();
        }
      })
      .catch((error) => {
        const errorMessage =
          error.response?.data?.Message ||
          error.response?.data ||
          "Si è verificato un errore. Riprovare più tardi.";
        setErrorMessage(errorMessage); // Impostiamo il messaggio di errore
        viewToggleModalErros(); // Mostriamo il modal di errore
      })
      .finally(() => {
        setIsLoading(false); // Fermiamo il caricamento
        toggleModalGenerateCSV(false); // Chiudiamo il modal
        console.log(
          "Caricamento completato, sia in caso di successo che errore.",
        );
      });
  };

  const sendRanking = () => {
    let passedValidation = true;
    setValidation(true);

    if (!editScoreData.rankingScore) passedValidation = false;

    if (passedValidation) {
      Repo.postUpdateRanking(apiToken, editScoreData)
        .then((response) => {
          if (response.status == 200) {
            toggleModalEditScore(!editScoreData);
            props.apiGet();
            setValidation(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setValidation(false);
        });
    }
  };

  const sendHours = (id) => {
    // console.log("sendHours" + id);
    let passedValidation = true;
    setValidation(true);
    // console.log("passedValidation 1" + passedValidation);
    //if (!editHoursData.weeklyHour) passedValidation = false;
    if (passedValidation) {
      let hoursValidation = true;
      var obj = {};
      setWeeklyHourValidation(true);

      obj = {
        id: id,
        state: 2,
        weeklyHour: editHoursData.weeklyHour,
      };

      //    console.log("passedValidation 2" + passedValidation);

      Repo.postConfirmUser(apiToken, JSON.stringify(obj))
        .then((response) => {
          if (response.status == 200) {
            toggleModalEditHours(!editHoursData);
            props.apiGet();
            setValidation(false);
          }
        })
        .catch((error) => {
          setErrorMessage(
            error.response?.data?.Message ||
              error.response?.data ||
              "MESSAGE_ERROR_DEFAULT",
          );
          viewToggleModalErros();
        })
        .finally(() => {
          toggleModalEditHours(false);
        });
    }
  };

  const bodyRanking = () => {
    return (
      <>
        <div className="row">
          Confermi di voler modificare il punteggio della graduatoria per
          l'utente selezionato?
        </div>
        <div className="row mt-4">
          <div className="col-4">
            <Input
              id={"ranking" + editScoreData.id}
              name={"ranking" + editScoreData.id}
              label="Punteggio Graduatoria"
              value={
                editScoreData.rankingScore
                  ? editScoreData.rankingScore.toString()
                  : ""
              }
              onChange={(e) =>
                setEditScoreData({
                  ...editScoreData,
                  rankingScore: parseInt(e.target.value),
                })
              }
              {...(validation &&
                !editScoreData.rankingScore && {
                  infoText: "Il campo non può essere vuoto!",
                  className: "text-danger",
                })}
            />
          </div>
        </div>
      </>
    );
  };

  const bodyError = (error) => {
    return <p className="p-3 mb-2 text-danger">{error}</p>;
  };

  const bodyHours = () => {
    //  console.log(editHoursData);

    return (
      <>
        <div className="row">
          Confermi di voler modificare le ore per l'utente selezionato?
        </div>
        <div className="row mt-4">
          <div className="col-4">
            <Input
              id={"weeklyHour" + editHoursData.id}
              name={"weeklyHour" + editHoursData.id}
              label="Ore bando"
              type="number"
              value={
                editHoursData.weeklyHour
                  ? editHoursData.weeklyHour.toString()
                  : "0"
              }
              onChange={(e) =>
                setEditHoursData({
                  ...editHoursData,
                  weeklyHour: parseFloat(e.target.value),
                })
              }
            />
          </div>
        </div>
      </>
    );
  };

  const expandedRow = (x) => {
    return (
      <>
        <tr
          className="collapse accordion-collapse"
          id={"collapseExample_" + x.id}
          data-bs-parent={"#collapseExample_" + x.id}
        >
          <td colSpan="12">
            <div
              className="col"
              style={{ position: "absolute", width: "auto" }}
            >
              <p>
                <b>{x.detail}</b>
              </p>{" "}
            </div>

            {x.state == "REFUSED" ? (
              <div className="row mt-2">
                <div className="col-12">
                  <button
                    type="button"
                    className="btn btn-outline-success float-right p-2"
                    title="Riattiva utente"
                    onClick={() => {
                      props.setSub(x);
                      toggleReactiveRefusedUserModal(
                        !isOpenReactiveRefusedUser,
                      );
                    }}
                  >
                    <svg className="icon icon-success">
                      <use href={`${iconSprite}#it-unlocked`} />
                    </svg>
                  </button>
                </div>
              </div>
            ) : (
              <div className="row justify-content-end">
                <div className="col-lg-0 mx-1">
                  <div className="col-4 p-2">
                    <EmailIcon email={x.user.email} />
                  </div>
                </div>

                <div className="col-lg-0 mx-1">
                  <button
                    type="button"
                    className="btn btn-outline-primary p-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Modifica Punteggio"
                    onClick={() => {
                      toggleModalEditScore(!editScore);
                      setEditScoreData({
                        id: x.id,
                        rankingScore: parseInt(x.rankingScore),
                        name: (
                          x.user.firstName +
                          " " +
                          x.user.lastName
                        ).toUpperCase(),
                      });
                    }}
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-chart-line`} />
                    </svg>
                  </button>
                </div>

                <div className="col-lg-0 mx-1">
                  <button
                    type="button"
                    className="btn btn-outline-primary p-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Modifica ore"
                    onClick={() => {
                      toggleModalEditHours(!editHours);
                      //   console.log(x.id);
                      setEditHoursData({
                        id: x.id,
                        weeklyHour: parseFloat(x.weeklyHour),
                        name: (
                          x.user.firstName +
                          " " +
                          x.user.lastName
                        ).toUpperCase(),
                      });
                    }}
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-clock`} />
                    </svg>
                  </button>
                </div>

                <div className="col-0 mx-2">
                  <Link
                    to={`/lista_utenti/dati_utente?citizen=${x.user.id}`}
                    className="btn btn-outline-primary p-2"
                    data-bs-toggle="tooltip"
                    data-bs-placement="bottom"
                    title="Profilo utente"
                    role="button"
                  >
                    <svg className="icon icon-primary">
                      <use href={`${iconSprite}#it-user`} />
                    </svg>
                  </Link>
                </div>

                {x.state == "VALIDATED" ? (
                  <>
                    <div className="col-0">
                      <Link
                        to={`/lista_bandi/bando/lista_pagamenti?id=${x.id}`}
                        className="btn btn-outline-primary float-right p-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Pagamenti"
                        role="button"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-card`} />
                        </svg>
                      </Link>
                    </div>

                    <div className="col-0 ml-2 mr-2">
                      <button
                        type="button"
                        className="btn btn-outline-primary p-2"
                        title="Invia pagamento"
                        disabled={parseFloat(x.user.isees[0].value) <= 3000}
                        onClick={() => {
                          toggleModalGenerateCSV(!isOpenGenerateCSV);
                          setSetFiscalcode(x.user.fiscalCode);
                          console.log(x);
                          setAnnouncementId(x.announcementId);
                        }}
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-upload`} />
                        </svg>
                      </button>
                    </div>

                    <div className="col-0 ml-2 mr-2">
                      <button
                        type="button"
                        className="btn btn-outline-danger float-right p-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Sospendi utente"
                        onClick={() => {
                          props.setSub(x);
                          toggleSuspendUserModal(!isOpenSuspendUser);
                        }}
                      >
                        <svg className="icon icon-danger">
                          <use href={`${iconSprite}#it-locked`} />
                        </svg>
                      </button>
                    </div>
                  </>
                ) : x.state == "LOADED" ? (
                  <div className="col-0 mr-2">
                    <Link
                      to={
                        "/lista_bandi/bando/lista_pagamenti?id=" +
                        x.id
                      }
                      className="btn btn-outline-primary float-right p-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Pagamenti"
                      role="button"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-card`} />
                      </svg>
                    </Link>
                  </div>
                ) : x.state == "SUSPENDED" ? (
                  <>
                    <div className="col-0 mr-2">
                      <Link
                        to={
                          "/lista_bandi/bando/lista_pagamenti?id=" +
                          x.id
                        }
                        className="btn btn-outline-primary float-right p-2"
                        data-bs-toggle="tooltip"
                        data-bs-placement="bottom"
                        title="Pagamenti"
                        role="button"
                      >
                        <svg className="icon icon-primary">
                          <use href={`${iconSprite}#it-card`} />
                        </svg>
                      </Link>
                    </div>
                    <div className="col-0 mr-2">
                      <button
                        type="button"
                        className="btn btn-outline-success float-right p-2"
                        title="Riattiva utente"
                        onClick={() => {
                          props.setSub(x);
                          toggleReactiveUserModal(!isOpenReactiveUser);
                        }}
                      >
                        <svg className="icon icon-success">
                          <use href={`${iconSprite}#it-unlocked`} />
                        </svg>
                      </button>
                    </div>
                  </>
                ) : (
                  <div className="col-0 mr-2">
                    <Link
                      to={
                        "/lista_bandi/bando/lista_pagamenti?id=" +
                        x.id
                      }
                      className="btn btn-outline-primary float-right p-2"
                      data-bs-toggle="tooltip"
                      data-bs-placement="bottom"
                      title="Pagamenti"
                      role="button"
                    >
                      <svg className="icon icon-primary">
                        <use href={`${iconSprite}#it-card`} />
                      </svg>
                    </Link>
                  </div>
                )}
              </div>
            )}
          </td>
        </tr>
      </>
    );
  };

  const parseItalianDate = (dateString) => {
    if (!dateString) return null;

    const parts = dateString.split("/");
    if (parts.length !== 3) return null;

    const [day, month, year] = parts;

    return new Date(parseInt(year), parseInt(month) - 1, parseInt(day));
  };

  const getAnprStatus = (dateString) => {
    if (!dateString) return "danger"; // NULL → rosso

    const date = parseItalianDate(dateString);
    if (!date) return "danger";

    const today = new Date();
    const diffTime = today - date;
    const diffDays = diffTime / (1000 * 60 * 60 * 24);

    if (diffDays > 30) return "warning"; // > 1 mese → giallo
    return "success"; // entro 1 mese → verde
  };

  const sortTable = (bool) => {
    var newArray = [];
    var newArray2 = [];

    if (bool == true) {
      if (changeSort == false) {
        if (props.sessionSubscriptionTemp2 !== undefined) {
          newArray =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2.sort(
              (subscription, subscription2) => {
                return (
                  parseFloat(subscription.user.isees[0].value) -
                  parseFloat(subscription2.user.isees[0].value)
                );
              },
            );
          props.setSessionSubscriptionTemp2(newArray);
          setChangeSort(true);
        } else {
          newArray =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp.sort(
              (subscription, subscription2) => {
                return (
                  parseFloat(subscription.user.isees[0].value) -
                  parseFloat(subscription2.user.isees[0].value)
                );
              },
            );
          props.setSessionSubscriptionTemp(newArray);
          setChangeSort(true);
        }
      }
      if (changeSort == true) {
        if (props.sessionSubscriptionTemp2 !== undefined) {
          newArray =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2.reverse(
              (subscription, subscription2) => {
                return (
                  parseFloat(subscription.user.isees[0].value) -
                  parseFloat(subscription2.user.isees[0].value)
                );
              },
            );
          props.setSessionSubscriptionTemp2(newArray);
          setChangeSort(false);
        } else {
          newArray =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp.reverse(
              (subscription, subscription2) => {
                return (
                  parseFloat(subscription.user.isees[0].value) -
                  parseFloat(subscription2.user.isees[0].value)
                );
              },
            );
          props.setSessionSubscriptionTemp(newArray);
          setChangeSort(false);
        }
      }
    } else {
      if (changeSortRanking == false) {
        if (props.sessionSubscriptionTemp2 !== undefined) {
          newArray =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2
              .filter((x) => x.rankingScore !== null)
              .sort((subscription, subscription2) => {
                return (
                  parseFloat(subscription.rankingScore) -
                  parseFloat(subscription2.rankingScore)
                );
              });

          newArray2 =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2.filter(
              (x) => x.rankingScore == null,
            );

          props.setSessionSubscriptionTemp2(newArray.concat(newArray2));
          setChangeSortRanking(true);
        } else {
          newArray =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp
              .filter((x) => x.rankingScore !== null)
              .sort((subscription, subscription2) => {
                return (
                  parseFloat(subscription.rankingScore) -
                  parseFloat(subscription2.rankingScore)
                );
              });

          newArray2 =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp.filter((x) => x.rankingScore == null);

          props.setSessionSubscriptionTemp(newArray.concat(newArray2));
          setChangeSortRanking(true);
        }
      } else if (changeSortRanking == true) {
        if (props.sessionSubscriptionTemp2 !== undefined) {
          newArray =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2
              .filter((x) => x.rankingScore !== null)
              .reverse((subscription, subscription2) => {
                return (
                  parseFloat(subscription.rankingScore) -
                  parseFloat(subscription2.rankingScore)
                );
              });
          newArray2 =
            props.sessionSubscriptionTemp2 &&
            props.sessionSubscriptionTemp2.filter(
              (x) => x.rankingScore == null,
            );

          props.setSessionSubscriptionTemp2(newArray.concat(newArray2));
          setChangeSortRanking(false);
        } else {
          newArray =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp
              .filter((x) => x.rankingScore !== null)
              .reverse((subscription, subscription2) => {
                return (
                  parseFloat(subscription.rankingScore) -
                  parseFloat(subscription2.rankingScore)
                );
              });
          newArray2 =
            props.sessionSubscriptionTemp &&
            props.sessionSubscriptionTemp.filter((x) => x.rankingScore == null);

          props.setSessionSubscriptionTemp(newArray.concat(newArray2));
          setChangeSortRanking(false);
        }
      }
    }
  };

  return (
    <>
      <h5>
        <b>Utenti Iscritti</b>{" "}
        {props.sessionSubscriptionTemp &&
          props.sessionSubscriptionTemp.length > 0 && (
            <span
              className="badge badge-light"
              data-bs-toggle="tooltip"
              title="Numero utenti iscritti"
            >
              {props.sessionSubscriptionTemp.length}
            </span>
          )}
      </h5>
      <div
        className="row p-2 text-white rounded"
        style={{ backgroundColor: "#2e58a6" }}
      >
        <div className="col-lg-12 text-right">
          <button
            type="button"
            className="btn btn-outline-white  responsive p-2 mr-2"
            onClick={() => props.toggleReset(!props.isOpenReset)}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-restore`} />
            </svg>
            <span className="align-middle">Ripristina ore</span>
          </button>

          <button
            type="button"
            className="btn btn-outline-white  responsive p-2 mr-2"
            onClick={() => showFile()}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-download`} />
            </svg>
            <span className="align-middle">Scarica template</span>
          </button>

          <button
            type="button"
            className="btn btn-outline-white responsive p-2 mr-2"
            onClick={() => props.toggleModalImport(!props.isOpenImport)}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-upload`} />
            </svg>
            <span className="align-middle">Importa dati</span>
          </button>

          <button
            type="button"
            className="btn btn-outline-white p-2 mr-2"
            onClick={() => props.downloadList()}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-download`} />
            </svg>{" "}
            <span className="align-middle">Lista utenti</span>
          </button>

          <button
            type="button"
            className="btn btn-outline-white p-2 mr-2"
            onClick={() => props.toggleModal(!props.isOpen)}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-plus-circle`} />
            </svg>{" "}
            <span className="align-middle">Iscrivi utente</span>
          </button>

          <button
            type="button"
            className="btn btn-outline-white p-2 mr-2"
            disabled={!props.sessionSubscriptionTemp || props.sessionSubscriptionTemp.length === 0}
            onClick={() => toggleModalDeleteAll(true)}
          >
            <svg className="icon icon-white">
              <use href={`${iconSprite}#it-delete`} />
            </svg>{" "}
            <span className="align-middle">Cancella iscritti</span>
          </button>

          <div className="d-inline-block ml-2">
            {props.session?.externalId != null && (
              <FileDownload
                apiToken={apiToken}
                versioneServizioId={props.session.externalId}
                sovrascrivi={1}
                reload={true}
              />
            )}
          </div>
        </div>
      </div>

      {props.sessionSubscriptionTemp &&
      props.sessionSubscriptionTemp.length > 0 ? (
        <>
          <div className="row mt-3 mb-2 align-items-end">
            <div className="col-lg-4">
              <Input
                id="searchIscritti"
                label="Nome, cognome o codice fiscale"
                type="search"
                name="search"
                autoComplete="off"
                value={props.filterSubscribed?.search || ""}
                onChange={(e) =>
                  props.setFilterSubscribed({
                    ...props.filterSubscribed,
                    search: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-lg-2">
              <Input
                id="iseeMin"
                label="ISEE minimo"
                type="number"
                name="iseeMin"
                autoComplete="off"
                value={props.filterSubscribed?.iseeMin || ""}
                onChange={(e) =>
                  props.setFilterSubscribed({
                    ...props.filterSubscribed,
                    iseeMin: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-lg-2">
              <Input
                id="iseeMax"
                label="ISEE massimo"
                type="number"
                name="iseeMax"
                autoComplete="off"
                value={props.filterSubscribed?.iseeMax || ""}
                onChange={(e) =>
                  props.setFilterSubscribed({
                    ...props.filterSubscribed,
                    iseeMax: e.target.value,
                  })
                }
              />
            </div>
            <div className="col-lg-3">
              <select
                id="filterState"
                className="form-control"
                value={props.filterSubscribed?.state || ""}
                onChange={(e) =>
                  props.setFilterSubscribed({
                    ...props.filterSubscribed,
                    state: e.target.value,
                  })
                }
              >
                <option value="">Stato tutti</option>
                <option value="LOADED">Da validare</option>
                <option value="VALIDATED">Confermato</option>
                <option value="SUSPENDED">Sospeso</option>
                <option value="ADDED">Aggiunto</option>
                <option value="REFUSED">Rifiutato</option>
                <option value="PAGAMENTO">Pagamento</option>
              </select>
            </div>
          </div>
          <div className="table-responsive rounded mt-1">
            <table
              className="table table-hover"
              style={{ border: "1px solid #d6dce3" }}
            >
              <thead>
                <tr>
                  <th
                    className="text-center col-1"
                    style={{ cursor: "pointer" }}
                    onClick={() => sortTable(false)}
                    scope="col"
                  >
                    <a
                      data-bs-toggle="tooltip"
                      data-bs-placement="top"
                      title="GRADUATORIA"
                    >
                      Graduatoria
                    </a>
                    {changeSortRanking ? (
                      <svg className="icon">
                        <use
                          xlinkHref={`${iconSprite}#it-arrow-up-triangle`}
                        ></use>
                      </svg>
                    ) : (
                      <svg className="icon">
                        <use
                          xlinkHref={`${iconSprite}#it-arrow-down-triangle`}
                        ></use>
                      </svg>
                    )}
                  </th>
                  <th scope="col">Codice fiscale</th>
                  <th scope="col">Nominativo</th>
                  <th
                    className="text-center"
                    scope="col"
                    style={{ cursor: "pointer" }}
                    onClick={() => sortTable(true)}
                  >
                    ISEE
                    {changeSort ? (
                      <svg className="icon">
                        <use
                          xlinkHref={`${iconSprite}#it-arrow-up-triangle`}
                        ></use>
                      </svg>
                    ) : (
                      <svg className="icon">
                        <use
                          xlinkHref={`${iconSprite}#it-arrow-down-triangle`}
                        ></use>
                      </svg>
                    )}
                  </th>
                  {props.session.service &&
                  props.session.service.name.toLowerCase().includes("taxi") ? (
                    <th className="text-center" scope="col">
                      Corse
                    </th>
                  ) : (
                    <th className="text-center" scope="col">
                      Ore
                    </th>
                  )}
                  <th className="text-center" scope="col">
                    Costo
                  </th>
                  <th scope="col">Stato</th>
                </tr>
              </thead>
              <tbody>
                {props.sessionSubscription &&
                  props.sessionSubscription.length > 0 &&
                  props.sessionSubscription.map((x, index) => (
                    <React.Fragment key={index}>
                      {x.user && (
                        <>
                          <tr
                            height="3em"
                            title={x.dataUpdate}
                            style={{
                              border:
                                (x.state === "VALIDATED" ||
                                  x.state === "ADDED") &&
                                parseInt(x.user.isees[0]?.year, 10) !==
                                  parseInt(props.session.year, 10)
                                  ? "2px solid red"
                                  : "none",
                            }}
                          >
                            <td className="text-center" scope="row">
                              <strong>
                                {x.rankingScore ? x.rankingScore : "-"}
                              </strong>
                            </td>
                            <td scope="row"  style={{ minWidth: "250px" }}>
                                                            <span
                                title={
                                  x.user.dataAggAnpr
                                    ? `Ultimo aggiornamento ANPR: ${x.user.dataAggAnpr}`
                                    : "Mai aggiornato ANPR"
                                }
                              >
                                <svg
                                  className={`icon icon-${getAnprStatus(x.user.dataAggAnpr)}`}
                                >
                                  <use href={`${iconSprite}#it-check-circle`} />
                                </svg>
                              </span>
                              {x.user.fiscalCode && x.user.fiscalCode}
                            </td>
                            <td>
                              {x.user.lastName} {x.user.firstName}
                            </td>

                    

                            {x.user.isees.length > 0 ? (
                              <td className="text-right fw-light">
                                {x.user.isees[0].value && (
                                  <>
                                    {parseFloat(
                                      x.user.isees[0].value,
                                    ).toLocaleString("it-IT")}
                                    &nbsp;€
                                  </>
                                )}
                                <br />
                                <b>
                                  {x.user.isees[0]?.year == "1900"
                                    ? "Errore ISEE"
                                    : x.user.isees[0]?.year}
                                </b>
                                {x.user.dataDecesso?.trim() ? (
                                  <span
                                    className="d-inline-flex align-middle"
                                    title={`Deceduto il ${x.user.dataDecesso}`}
                                  >
                                    <svg className="icon icon-danger">
                                      <use href={`${iconSprite}#it-user`} />
                                    </svg>
                                  </span>
                                ) : (
                                  <span
                                    className="d-inline-flex align-middle"
                                    title="Utente attivo"
                                  >
                                    <svg className="icon icon-success">
                                      <use href={`${iconSprite}#it-user`} />
                                    </svg>
                                  </span>
                                )}
                              </td>
                            ) : (
                              <td>ISEE non caricato</td>
                            )}
                            <td className="text-right">
                              {x.weeklyHour ? x.weeklyHour : "-"}
                            </td>
                            <td className="text-right">
                              {x.cost !== null &&
                                parseFloat(x.cost).toLocaleString("it-IT")}
                              &nbsp;€{" "}
                            </td>
                            {x.state == "VALIDATED" ? (
                              <td>
                                <div className="row"  style={{ minWidth: "200px" }}>
                                  <div
                                    className="col-4 p-2"
                                    data-bs-toggle="tooltip"
                                    title="Confermato"
                                  >
                                    <svg className="icon icon-success">
                                      <use
                                        xlinkHref={`${iconSprite}#it-check-circle`}
                                      ></use>
                                    </svg>
                                  </div>
                                  <div className="col-4">
                                    <button
                                      className="btn btn-outline-danger btn-xs"
                                      type="button"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Eliminazione iscrizione"
                                      onClick={() => {
                                        toggleModalUnsubscribe(
                                          !isOpenUnsubscribe,
                                        );
                                        setId(x.id);
                                        setUserId(x.user.id);
                                      }}
                                    >
                                      <svg className="icon icon-danger">
                                        <use href={`${iconSprite}#it-delete`} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </td>
                            ) : x.state == "SUSPENDED" ? (
                              <td>
                                <div className="row"  style={{ minWidth: "200px" }}>
                                  <div className="col-4 p-2" title="Sospeso">
                                    <svg className="icon icon-dark">
                                      <use
                                        xlinkHref={`${iconSprite}#it-ban`}
                                      ></use>
                                    </svg>
                                  </div>

                                  <div className="col-4">
                                    <button
                                      className="btn btn-outline-secondary btn-xs"
                                      type="button"
                                      data-toggle="tooltip"
                                      data-placement="top"
                                      title="Eliminazione iscrizione"
                                    >
                                      <svg className="icon icon-secondary">
                                        <use href={`${iconSprite}#it-delete`} />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </td>
                            ) : x.state == "LOADED" ? (
                              <td>
                                <div className="row"  style={{ minWidth: "200px" }}>
                                  <div
                                    className="col-4 p-2"
                                    title="Da validare"
                                  >
                                    <svg className="icon icon-warning">
                                      <use
                                        xlinkHref={`${iconSprite}#it-warning-circle`}
                                      />
                                    </svg>
                                  </div>

                                  <div className="col-4">
                                    <button
                                      type="button"
                                      className="btn rounded btn-outline-success btn-xs"
                                      title="Conferma"
                                      onClick={() => {
                                        props.setSub(x);
                                        toggleModalConfirmUser(
                                          !isOpenConfirmUser,
                                        );
                                      }}
                                    >
                                      <svg className="icon icon-success">
                                        <use
                                          xlinkHref={`${iconSprite}#it-check`}
                                        />
                                      </svg>
                                    </button>
                                  </div>

                                  <div className="col-4">
                                    <button
                                      type="button"
                                      className="btn rounded btn-outline-danger btn-xs"
                                      title="Rifiuta"
                                      onClick={() => {
                                        props.setSub(x);
                                        toggleRefuseUserModal(
                                          !isOpenRefuseUser,
                                        );
                                      }}
                                    >
                                      <svg className="icon icon-danger">
                                        <use
                                          xlinkHref={`${iconSprite}#it-close`}
                                        />
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </td>
                            ) : x.state == "ADDED" ? (
                              <td>
                                <div className="row"  style={{ minWidth: "200px" }}>
                                  <div className="col-4 p-2" title="Aggiunto">
                                    <svg className="icon icon-warning">
                                      <use
                                        xlinkHref={`${iconSprite}#it-primary-circle`}
                                      />
                                    </svg>
                                  </div>

                                  <div className="col-4">
                                    <button
                                      type="button"
                                      className="btn rounded btn-outline-success btn-xs "
                                      data-bs-toggle="tooltip"
                                      title="Conferma"
                                      onClick={() => {
                                        props.setSub(x);
                                        toggleModalConfirmUser(
                                          !isOpenConfirmUser,
                                        );
                                      }}
                                    >
                                      <svg className="icon icon-success">
                                        <use
                                          xlinkHref={`${iconSprite}#it-check`}
                                        ></use>
                                      </svg>
                                    </button>
                                  </div>
                                  <div className="col-4">
                                    <button
                                      type="button"
                                      className="btn rounded btn-outline-danger btn-xs"
                                      data-bs-toggle="tooltip"
                                      title="Rifiuta"
                                      onClick={() => {
                                        props.setSub(x);
                                        toggleRefuseUserModal(
                                          !isOpenRefuseUser,
                                        );
                                      }}
                                    >
                                      <svg className="icon icon-danger">
                                        <use
                                          xlinkHref={`${iconSprite}#it-close`}
                                        ></use>
                                      </svg>
                                    </button>
                                  </div>
                                </div>
                              </td>
                            ) : x.state == "REFUSED" ? (
                              <td>
                                <div className="row text-right"  style={{ minWidth: "200px" }}>
                                  <div
                                    className="col-8 mt-2"
                                    data-bs-toggle="tooltip"
                                    data-bs-placement="top"
                                    title="Rifiutato"
                                  >
                                    <strong className="text-danger"></strong>{" "}
                                    <svg className="icon icon-danger">
                                      <use
                                        xlinkHref={`${iconSprite}#it-close-circle`}
                                      ></use>
                                    </svg>
                                  </div>
                                </div>
                              </td>
                            ) : (
                              <td>
                                <span className="text-muted">
                                  Stato non gestito
                                </span>
                              </td>
                            )}
                            <td>
                              <div className="col-4">
                                <button
                                  type="button"
                                  className="btn rounded btn-xs"
                                  data-toggle="collapse"
                                  href={"#collapseExample_" + x.id}
                                  role="button"
                                  aria-expanded="false"
                                  aria-controls={"collapseExample_" + x.id}
                                  data-bs-toggle="tooltip"
                                  data-bs-placement="bottom"
                                  title="Opzioni"
                                  onClick={() =>
                                    setExpandedRows((prev) => ({
                                      ...prev,
                                      [x.id]: !prev[x.id],
                                    }))
                                  }
                                >
                                  <svg className="icon icon-primary">
                                    <use
                                      xlinkHref={`${iconSprite}#${
                                        expandedRows[x.id]
                                          ? "it-collapse"
                                          : "it-expand"
                                      }`}
                                    />
                                  </svg>
                                </button>
                              </div>
                            </td>
                          </tr>
                          {expandedRow(x)}
                        </>
                      )}
                    </React.Fragment>
                  ))}
              </tbody>
            </table>
          </div>

          {props.sessionSubscriptionTemp &&
            (props.changeArray == false ? (
              <Pagination
                key={
                  props.sessionSubscriptionTemp + changeSort + changeSortRanking
                }
                items={props.sessionSubscriptionTemp}
                setCurrentItems={props.setSessionSubscription}
                itemsPerPage={itemsPerPage}
              ></Pagination>
            ) : (
              <Pagination
                key={
                  props.sessionSubscriptionTemp2 +
                  changeSort +
                  changeSortRanking
                }
                items={props.sessionSubscriptionTemp2}
                setCurrentItems={props.setSessionSubscription}
                itemsPerPage={itemsPerPage}
              ></Pagination>
            ))}

          <div className="row mt-4">
            <div className="col-lg-11">
              <p className="mt-2">
                {itemsPerPage < props.sessionSubscription.length ? (
                  <>
                    {" "}
                    Mostro <strong>{itemsPerPage}</strong> su{" "}
                    <strong>{props.sessionSubscription.length}</strong>
                  </>
                ) : (
                  <>
                    {" "}
                    Mostro <strong>
                      {props.sessionSubscription.length}
                    </strong>{" "}
                    su <strong>{props.sessionSubscription.length}</strong>
                  </>
                )}
              </p>
            </div>
            <div className="col-lg-1 float-right">
              <Select
                aria-label="Servizio"
                defaultMenuIsOpen={false}
                required
                icon={false}
                name="servizio"
                id="servizio"
                options={[
                  { value: 10, label: "10" },
                  { value: 25, label: "25" },
                  { value: 50, label: "50" },
                ]}
                onChange={(e) => setItemsPerPage(e.value)}
                placeholder={itemsPerPage.toString()}
              />
            </div>
          </div>
        </>
      ) : (
        <span className="text mt-3">Non ci sono utenti iscritti.</span>
      )}

      <ModalComponent
        labelledBy="modalConfirm"
        isOpen={isOpenUnsubscribe}
        toggleModal={() => toggleModalUnsubscribe(!isOpenUnsubscribe)}
        header="Eliminazione iscrizione utente"
        body="Confermi di voler eliminare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => unsubscribeUser()}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalDeleteAll"
        isOpen={isOpenDeleteAll}
        toggleModal={() => toggleModalDeleteAll(!isOpenDeleteAll)}
        header="Cancella tutti gli iscritti"
        body="Confermi di voler eliminare TUTTI gli iscritti di questo bando? Verranno cancellate anche le relative righe Excel. L'operazione non è reversibile."
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => deleteAllSubscriptions()}
        isLoading={isLoading}
        disabled={isLoading}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={() => toggleModalEditScore(!editScore)}
        isOpen={editScore}
        header={"Modifica punteggio graduatoria di " + editScoreData.name}
        body={bodyRanking()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendRanking()}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleModalConfirmUser}
        isOpen={isOpenConfirmUser}
        header="Conferma Utente"
        body={returnBodyModalConfirmUser()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleRefuseUserModal}
        isOpen={isOpenRefuseUser}
        header="Iscrizione utente"
        body="Confermi di voler rifiutare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(3, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleSuspendUserModal}
        isOpen={isOpenSuspendUser}
        header="Sospensione utente"
        body="Confermi di voler sospendere l'iscrizione dell'utente selezionato? Potrai riattivarlo in seguito"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(4, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleReactiveUserModal}
        isOpen={isOpenReactiveUser}
        header="Riattiva utente"
        body="Confermi di voler riattivare l'iscrizione dell'utente selezionato?"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleReactiveRefusedUserModal}
        isOpen={isOpenReactiveRefusedUser}
        header="Riattiva utente"
        body="Confermi di voler riattivare l'utente selezionato? Dovrai in seguito accettare l'iscrizione"
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => suspendUser(0, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalConfirm"
        toggleModal={toggleModalConfirmHours}
        isOpen={isOpenConfirmHours}
        header="Conferma ore utente"
        body={returnBodyModalHoursUser()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => confirmUser(2, props.sub)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalEditHours"
        toggleModal={() => toggleModalEditHours(!editHours)}
        isOpen={editHours}
        header={"Modifica ore bando di " + editHoursData.name}
        body={bodyHours()}
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendHours(editHoursData.id)}
      ></ModalComponent>

      <ModalComponent
        labelledBy="modalEditHours"
        toggleModal={() => toggleModalErros(!isError)}
        isOpen={isError}
        header="Errore"
        body={bodyError(errorMessage)}
        buttonConfirm="Conferma"
        function={() => toggleModalErros(false)}
      ></ModalComponent>

      <ModalComponent
        toggleModal={toggleModalGenerateCSV}
        isOpen={isOpenGenerateCSV}
        header="Invio singolo pagamento"
        body={
          <BodyGenerateCsv
            sendImportCSV={sendImportCSV}
            setSendImportCSV={setSendImportCSV}
          />
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => sendMyPay()}
        isLoading={isLoading}
        disabled={isLoading}
      ></ModalComponent>
      {isLoading && <Loader />}
    </>
  );
};
export default ListUsers;
